import { useAppSelector } from '@store/hooks';
import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import Loading from '../../../Loading';

const HomeRoute: FC = () => {
  const { isAuthenticated, sessionLoading, authChecked } = useAppSelector(
    (state) => state.auth,
  );

  if (!authChecked || sessionLoading) {
    return <Loading size={50} containerMode />;
  }

  return isAuthenticated ? (
    <Navigate to="/home" replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default HomeRoute;
